import {useInfiniteQuery, useMutation, useQuery} from "@tanstack/react-query";
import {
    apiDeleteComment,
    apiGetMyComment,
    apiListComments,
    apiPostComment,
    apiUpdateComment
} from "../../../../data/api/comment";

export const useListComments = (args, config) => {
    return useInfiniteQuery({
        queryKey: ['comments', args],
        queryFn: ({pageParam = 1}) => apiListComments({...args, page: pageParam}),
        ...config,
        getNextPageParam: lastPage =>
            lastPage.meta.currentPage < lastPage.meta.lastPage ? lastPage.meta.currentPage + 1 : undefined,
    })
}
export const usePostComment = () => {
    return useMutation({
        mutationFn: (data) => apiPostComment(data)
    })
}
export const useGetComment = (args, config) => {
    return useQuery({
        queryKey: ['comments', args],
        queryFn: () =>apiGetMyComment(args),
        ...config,
    })
}
export const useUpdateComment = () => {
    return useMutation({
        mutationFn: ({id, data}) => apiUpdateComment(id,data)
    })
}
export const useDeleteComment = () => {
    return useMutation({
        mutationFn: ({id}) => apiDeleteComment(id),
    })
}